import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './sidebar'; // Ensure correct import path

const Layout = () => {
  const location = useLocation();
  const showSidebar = location.pathname === '/smart-operator' || location.pathname === '/floor-layout' || location.pathname === '/gcode-optimizer' ||
    location.pathname === '/recipe-master' ||
    location.pathname === '/andon-dashboard' ||
    location.pathname === '/shift' ||
    location.pathname === '/machine-card' ||
    location.pathname === '/shift-registration' ||
    location.pathname === '/component-registration' ||
    location.pathname === '/reason-registration' ||
    // location.pathname === '/company' ||
    location.pathname === '/CurrentShift' ||
    location.pathname === '/analytics' ||
    location.pathname === '/machines' ||
    location.pathname === '/operator-registration' ||
    location.pathname === '/operator-details' ||
    location.pathname === '/allocation' ||
    location.pathname === '/machinemm' ||
    location.pathname === '/reports' ||
    location.pathname === '/deviceoee' ||
    location.pathname === '/teep' ||
    location.pathname === '/user-registration' ||
    location.pathname === '/machineutilization' ||
    location.pathname === '/production-analysis' ||
    location.pathname === '/deviceoee' ||
    location.pathname === '/machineutilization' ||
    location.pathname === '/cycletime' ||
    location.pathname === '/inprogresscycle' ||
    location.pathname === '/production-summary' ||
    location.pathname === '/production-runs' ||
    location.pathname === '/summary' ||
    location.pathname === '/analyticoee' ||
    location.pathname === '/inprogressoee' ||
    location.pathname === '/partwise-cycletime' ||
    location.pathname === '/machines-group' ||
    location.pathname === '/operator-leaderboard' ||
    location.pathname === '/notification-center' ||
    location.pathname === '/kpi-dashboard' ||
    location.pathname === '/group' ||
    location.pathname === '/production-overview' ||
    location.pathname === '/settings' ||
    location.pathname === '/production-metrics' ||
    location.pathname === '/bluecard' ||
    location.pathname === '/bluecarddetails' ||
    location.pathname === '/bluecardreport' ||
    location.pathname === '/quality' || 
    location.pathname === '/machine-status' ||
    location.pathname === '/erpjson' ||
    location.pathname === '/erpreportschedule' ||
    location.pathname === '/erpreport' ||
    location.pathname === '/holiday-list' ||
    location.pathname === '/operator-performance' ||
    location.pathname === '/ai-configuration' ||
    location.pathname === '/interlock-settings' ||
    location.pathname === '/tool-dashboard' ||
    location.pathname === '/maintenance-dashboard' ||
    location.pathname === '/mes-planning' ||
    location.pathname === '/production-orders' ||
    location.pathname === '/labour-board' ||
    location.pathname === '/work-orders' ||
    location.pathname === '/operator-queue' ||
    location.pathname === '/mes-reports' ||
    location.pathname === '/buildings' ||
    location.pathname === '/sites' ||
    location.pathname === '/process-master' ||
    location.pathname === '/operation-master' ||
    location.pathname === '/machine-capabilities' ||
    location.pathname === '/calibration-register' ||
    location.pathname === '/operator-qualifications' ||
    location.pathname === '/heat-treat-cycles' ||
    location.pathname === '/ndt-inspections' ||
    location.pathname === '/anodize-batches' ||
    location.pathname === '/route-card-follower' ||
    location.pathname === '/route-card-builder' ||
    location.pathname === '/jigging-panels' ||
    location.pathname === '/audit-trail' ||
    location.pathname === '/nadcap-dashboard' ||
    location.pathname === '/material-certs' ||
    location.pathname === '/scheduler' ||
    location.pathname === "/nc-log" ||
    location.pathname === "/rework-orders" ||
    location.pathname === "/bom-master" ||
    location.pathname === "/ecr" ||
    location.pathname === "/ecn" ||
    // ── PPW (Paperless Factory) — added 2026-06-18 ──
    location.pathname.startsWith('/paperless-factory') ||
    location.pathname.startsWith('/inspection') ||
    // ── Business (ERP) — added 2026-06-18 ──
    location.pathname === '/sales' ||
    location.pathname === '/purchase' ||
    location.pathname === '/inventory' ||
    location.pathname === '/bom' ||
    location.pathname === '/mrp' ||
    location.pathname === '/finance' ||
    location.pathname === '/crm' ||
    location.pathname === '/workforce' ||
    location.pathname === '/operation-setup' ||
    location.pathname === '/insights';

  return (
    <>
      {showSidebar && <Sidebar />} {/* Conditionally render the Sidebar */}
    </>
  );
};

export default Layout;
